export const Text = {
    // The styles all text have in common
    baseStyle: {
        margin: '0',
    },
};
